import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{staticClass:"mr-1",attrs:{"icon":"","x-small":"","color":_vm.thecolor},on:{"click":function($event){return _vm.$emit('click')}}},[_c(VIcon,[_vm._v(_vm._s(_vm.icon_name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }